// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X8zI8OR2U5pTMPBd0x1S {

    flex: 1 1 0%;

    overflow-y: auto;

    border-radius: 5px;

    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.X8zI8OR2U5pTMPBd0x1S .ant-table-cell {

    font-size: 0.75rem;

    line-height: 1rem
}

.Y6BGNam5r8v8bRIB1KNI {

    height: 38px;

    width: 155px;

    --tw-border-opacity: 1;

    border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.Y6BGNam5r8v8bRIB1KNI:hover {

    --tw-border-opacity: 1 !important;

    border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;

    --tw-bg-opacity: 1 !important;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(0 130 202 / var(--tw-text-opacity, 1)) !important
}

.d3ZU4R8FzjMfAxFfLMsn {

    height: 38px;

    width: 137px;

    --tw-bg-opacity: 1;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.d3ZU4R8FzjMfAxFfLMsn:hover {

    --tw-bg-opacity: 1 !important;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.ISqnixoNgKNDe60p76dK {

    border-radius: 0.375rem;

    --tw-bg-opacity: 1;

    background-color: rgb(242 250 254 / var(--tw-bg-opacity, 1));

    padding: 1.5rem
}

.N6s_uJJtFZ4ZenaH8dGg {

    display: grid;

    grid-template-columns: auto auto 1fr;

    align-items: center;

    gap: 1rem
}

.aUml9ibcQZfszPNb3W5j {

    display: flex;

    align-items: center;

    gap: 0.5rem;

    text-align: center
}

.lMg3yfzbonyx0XhLTpQ6 {

    height: 1.5rem;

    width: 1.5rem
}

.ERfrtLaXejaHphiozr4R {

    font-size: 12px;

    font-weight: 500;

    --tw-text-opacity: 1;

    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.otOSuXi8RBMLOnot4azI {

    display: flex;

    justify-content: flex-start;

    padding-left: 1.5rem;

    font-family: Noto Sans;

    font-size: 12px;

    font-weight: 600;

    --tw-text-opacity: 1;

    color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.sJD1bI39zcRsneWAHIxQ {

    display: flex;

    align-items: center;

    gap: 0.5rem
}

.GUPF92g7NCeWGDYXKwLw {

    grid-row: span 4 / span 4;

    display: flex;

    align-items: flex-start;

    justify-content: flex-end;

    gap: 0.75rem
}

.Vzz_LijzIDdACSjyEkZR td {

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}

.HCmbLtMIdhnTIpk2zLbU td {

    --tw-bg-opacity: 1;

    background-color: rgb(247 251 253 / var(--tw-bg-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/PawnTickets/PawnTickets.module.css"],"names":[],"mappings":"AACE;;IAAA,YAAqD;;IAArD,gBAAqD;;IAArD,kBAAqD;;IAArD,6EAAqD;;IAArD,iGAAqD;;IAArD;AAAqD;;AAIrD;;IAAA,kBAAc;;IAAd;AAAc;;AAId;;IAAA,YAAkE;;IAAlE,YAAkE;;IAAlE,sBAAkE;;IAAlE,0DAAkE;;IAAlE,kBAAkE;;IAAlE,4DAAkE;;IAAlE,oBAAkE;;IAAlE;AAAkE;;AAIlE;;IAAA,iCAAkD;;IAAlD,qEAAkD;;IAAlD,6BAAkD;;IAAlD,uEAAkD;;IAAlD,+BAAkD;;IAAlD;AAAkD;;AAIlD;;IAAA,YAAiD;;IAAjD,YAAiD;;IAAjD,kBAAiD;;IAAjD,0DAAiD;;IAAjD,oBAAiD;;IAAjD;AAAiD;;AAIjD;;IAAA,6BAAgC;;IAAhC,qEAAgC;;IAAhC,+BAAgC;;IAAhC;AAAgC;;AAIhC;;IAAA,uBAAsC;;IAAtC,kBAAsC;;IAAtC,4DAAsC;;IAAtC;AAAsC;;AAItC;;IAAA,aAAwD;;IAAxD,oCAAwD;;IAAxD,mBAAwD;;IAAxD;AAAwD;;AAIxD;;IAAA,aAA0C;;IAA1C,mBAA0C;;IAA1C,WAA0C;;IAA1C;AAA0C;;AAI1C;;IAAA,cAAc;;IAAd;AAAc;;AAId;;IAAA,eAAyD;;IAAzD,gBAAyD;;IAAzD,oBAAyD;;IAAzD;AAAyD;;AAIzD;;IAAA,aAAkF;;IAAlF,2BAAkF;;IAAlF,oBAAkF;;IAAlF,sBAAkF;;IAAlF,eAAkF;;IAAlF,gBAAkF;;IAAlF,oBAAkF;;IAAlF;AAAkF;;AAIlF;;IAAA,aAA8B;;IAA9B,mBAA8B;;IAA9B;AAA8B;;AAI9B;;IAAA,yBAAoD;;IAApD,aAAoD;;IAApD,uBAAoD;;IAApD,yBAAoD;;IAApD;AAAoD;;AAIpD;;IAAA,kBAAe;;IAAf;AAAe;;AAIf;;IAAA,kBAAwB;;IAAxB;AAAwB","sourcesContent":[".tableWrapper {\n  @apply shadow-md rounded-[5px] overflow-y-auto flex-1;\n}\n\n.tableWrapper :global(.ant-table-cell) {\n  @apply text-xs;\n}\n\n.clearButton {\n  @apply bg-white text-secondary border-secondary w-[155px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-secondary !border-secondary;\n}\n\n.applyButton {\n  @apply bg-secondary text-white w-[137px] h-[38px];\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n\n.expandableBG {\n  @apply bg-tableExpandBG p-6 rounded-md;\n}\n\n.totalItems {\n  @apply grid grid-cols-[auto_auto_1fr] gap-4 items-center;\n}\n\n.months {\n  @apply flex items-center text-center gap-2;\n}\n\n.expandIcon {\n  @apply w-6 h-6;\n}\n\n.labelTitle {\n  @apply text-gray-600 font-dashboardMain text-dashboardSub;\n}\n\n.values {\n  @apply text-secondary text-dashboardSub font-h4 font-inter flex justify-start pl-6;\n}\n\n.fullLabel {\n  @apply flex items-center gap-2;\n}\n\n.button {\n  @apply row-span-4 flex gap-3 justify-end items-start;\n}\n\n.evenRow td {\n  @apply bg-white;\n}\n\n.oddRow td {\n  @apply bg-tableEvenRowBG;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `X8zI8OR2U5pTMPBd0x1S`,
	"clearButton": `Y6BGNam5r8v8bRIB1KNI`,
	"applyButton": `d3ZU4R8FzjMfAxFfLMsn`,
	"expandableBG": `ISqnixoNgKNDe60p76dK`,
	"totalItems": `N6s_uJJtFZ4ZenaH8dGg`,
	"months": `aUml9ibcQZfszPNb3W5j`,
	"expandIcon": `lMg3yfzbonyx0XhLTpQ6`,
	"labelTitle": `ERfrtLaXejaHphiozr4R`,
	"values": `otOSuXi8RBMLOnot4azI`,
	"fullLabel": `sJD1bI39zcRsneWAHIxQ`,
	"button": `GUPF92g7NCeWGDYXKwLw`,
	"evenRow": `Vzz_LijzIDdACSjyEkZR`,
	"oddRow": `HCmbLtMIdhnTIpk2zLbU`
};
export default ___CSS_LOADER_EXPORT___;
